import { getUserToken } from "../helpers/authHelper";
import api from "../api";

export async function FetchStoreList() {
  return await api({
    method: "get",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/store/store-list`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-Lang_id": localStorage.getItem("lang_id") || "",
    },
  });
}

export async function FetchStoreById(id) {
  return await api({
    method: "get",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/store/store-list/get/${id}`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-Lang_id": localStorage.getItem("lang_id") || "",
    },
  });
}

export async function DeleteStoreRecord(storeId) {
  return await api({
    method: "put",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/store/delete-store/${storeId}`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}

export async function CreateStoreRecord(data) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/store/create-store/`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-Lang_id": localStorage.getItem("lang_id") || "",
    },
    "content-type": "multipart/form-data",
  });
}

export async function UpdateStoreRecord(data,id) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/store/edit-store/${id}`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-Lang_id": localStorage.getItem("lang_id") || "",
    },
    "content-type": "multipart/form-data",
  });
}
